import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { setIsEditing, setIsOpen } from '../../../../state';
import { usePaymentQuery } from '../../../../api/usePaymentQuery';

interface FormFooterProps {
  isLoading?: boolean;
}

export const FormFooter: React.FC<FormFooterProps> = ({ isLoading }) => {
  const { data } = usePaymentQuery();

  const dispatch = useDispatch();

  const onCancel = useCallback(() => {
    if (!data) {
      return;
    }

    if (!data.currentPaymentOption) {
      dispatch(setIsOpen(false));

      return;
    }

    dispatch(setIsEditing(false));
  }, [data, dispatch]);

  return (
    <ModalFooter>
      <Button variant="subtleInactive" onClick={onCancel}>
        Cancel
      </Button>

      <Button variant="primary" ml="12" type="submit" isLoading={isLoading}>
        Save
      </Button>
    </ModalFooter>
  );
};
